/* eslint-disable react/prop-types */
/* eslint-disable jsx-a11y/no-autofocus */
/* eslint-disable jsx-a11y/media-has-caption */
import React, { useEffect, useState, useRef } from 'react';
import { useTheme } from '@mui/material/styles';
import { Card, CardContent, Typography, Button, IconButton, Box, OutlinedInput, LinearProgress, InputLabel, Badge } from '@mui/material';
import { FiX, FiImage, FiMic, FiFile, FiPlus, FiEdit3, FiTrash2, FiPlay } from 'react-icons/fi';
import { RiUploadCloud2Line } from 'react-icons/ri';

import axios from 'lib/axios';
import { useDispatch } from 'react-redux';
import { activeLoader } from 'store/reducers/loaderSlice';
import FileDownload from 'js-file-download';
import { toast } from 'sonner';

const EditPost = ({ setOpenEditor, post, content, user, setPosts, showSnack, setOpenOption }) => {
    const theme = useTheme();
    const imageInput = useRef(null);
    const textInput = useRef(null);
    const pdfInput = useRef(null);
    const audioInput = useRef(null);
    const [openImageUploader, setOpenImageUploader] = useState(post.image.length > 0 ? true : false);
    const [openPdfUploader, setOpenPdfUploader] = useState(post.files.length > 0 && post.image.length == 0 ? true : false);
    const [openAudioUploader, setOpenAudioUploader] = useState(post.audio.length > 0 && post.image.length == 0 ? true : false);
    const [text, setText] = useState(content);
    const [postImages, setPostImages] = useState([]);
    const [existingpostImages, setExistingPostImages] = useState(post.image.length > 0 ? post.image : []);
    const [existingpostVideos, setExistingPostVideos] = useState(post.video.length > 0 ? post.video : []);
    const [existingpostAudios, setExistingpostAudios] = useState(post.audio.length > 0 ? post.audio : []);
    const [existingpostPdfs, setExistingpostPdfs] = useState(post.files.length > 0 ? post.files : []);
    const [postAudios, setPostAudios] = useState([]);
    const [postaudiosData, setPostaudiosData] = useState([]);
    const [postMediaData, setPostMediaData] = useState([]);
    const [postMediaFiles, setPostMediaFiles] = useState([]);
    const [postPdfs, setPostPdfs] = useState([]);
    const [postPdfNames, setPostPdfNames] = useState([]);
    const [postPdfsData, setPostPdfsData] = useState([]);
    const [externalLink, setExternalLink] = useState(post.external_video_link ? post.external_video_link : null);
    const [loading, seLoading] = useState(false);
    const [uploadProgress, setUploadProgress] = useState(0);
    const [validatorMessage, setValidatorMessage] = useState([]);
    const dispatch = useDispatch();

    async function download_file(path) {
        try {
            const response = await axios({
                url: `${path}`,
                method: 'GET',
                responseType: 'blob'
            });
            const filename = path.split('/').pop();
            FileDownload(response.data, filename);
        } catch (err) {
            console.log('Error downloading file:', err);
        }
    }

    useEffect(() => {
        const handleEsc = (event) => {
            if (event.keyCode === 27) {
                handleClose();
            }
        };

        window.addEventListener('keydown', handleEsc);
        return () => window.removeEventListener('keydown', handleEsc);
    }, []);

    const toBase64 = (file) =>
        new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = () => resolve(reader.result);
            reader.onerror = (error) => reject(error);
        });

    const convertMedia = async () => {
        Array.from(imageInput.current.files).forEach(async (f) => {
            if (f.size < 52453290) {
                const data = await toBase64(f);
                const file = f;
                const url = URL.createObjectURL(f);
                setPostMediaData([...postMediaData, data]);
                setPostMediaFiles((prev) => [...prev, file]);
                setPostImages([...postImages, url]);
            } else {
                alert('Size Must Be Smaller Than 50MB');
            }
        });
    };

    const convertAudio = async () => {
        Array.from(audioInput.current.files).forEach(async (f) => {
            if (f.size < 52453290) {
                const file = f;
                const url = URL.createObjectURL(f);
                setPostaudiosData([...postaudiosData, file]);
                setPostAudios([...postAudios, url]);
            } else {
                alert('Size Must Be Smaller Than 50MB');
            }
        });
    };

    const convertPdf = async () => {
        Array.from(pdfInput.current.files).forEach(async (f) => {
            if (f.size < 52453290) {
                const file = f;
                const url = URL.createObjectURL(f);
                setPostPdfsData([...postPdfsData, file]);
                setPostPdfs([...postPdfs, url]);
                setPostPdfNames([...postPdfNames, f.name]);
            } else {
                alert('Size Must Be Smaller Than 50MB');
            }
        });
    };

    const removeMediaFile = (index) => {
        if (postImages[index]) {
            URL.revokeObjectURL(postImages[index]);
        }
        setPostImages((prev) => prev.filter((_, i) => i !== index));
        setPostMediaData((prev) => prev.filter((_, i) => i !== index));
        setPostMediaFiles((prev) => prev.filter((_, i) => i !== index));
    };

    const removeAudioFile = (index) => {
        if (postAudios[index]) {
            URL.revokeObjectURL(postAudios[index]);
        }
        setPostAudios((prev) => prev.filter((_, i) => i !== index));
        setPostaudiosData((prev) => prev.filter((_, i) => i !== index));
    };

    const removePdfFile = (index) => {
        if (postPdfs[index]) {
            URL.revokeObjectURL(postPdfs[index]);
        }
        setPostPdfs((prev) => prev.filter((_, i) => i !== index));
        setPostPdfNames((prev) => prev.filter((_, i) => i !== index));
        setPostPdfsData((prev) => prev.filter((_, i) => i !== index));
    };

    const removeExistingImage = (index) => {
        setExistingPostImages((prev) => prev.filter((_, i) => i !== index));
    };

    const removeExistingAudio = (index) => {
        setExistingpostAudios((prev) => prev.filter((_, i) => i !== index));
    };

    const removeExistingPdf = (index) => {
        setExistingpostPdfs((prev) => prev.filter((_, i) => i !== index));
    };

    const handleClose = () => {
        // Clean up object URLs
        postImages.forEach((url) => {
            if (url) URL.revokeObjectURL(url);
        });
        postAudios.forEach((url) => {
            if (url) URL.revokeObjectURL(url);
        });
        postPdfs.forEach((url) => {
            if (url) URL.revokeObjectURL(url);
        });

        setOpenEditor(false);
    };

    const updatePost = async () => {
        if (text.trim() === '') {
            setValidatorMessage([
                {
                    field: 'post_details',
                    message: 'Post details are required'
                }
            ]);
            return;
        }

        try {
            seLoading(true);
            setUploadProgress(0);
            dispatch(activeLoader(true));

            const formData = new FormData();
            formData.append('post_id', post.post_id);
            formData.append('content', text);
            // media
            formData.append('image_exist', existingpostImages.length > 0 ? true : false);
            formData.append('new_image_exist', postMediaData.length > 0 ? true : false);
            formData.append('old_images', JSON.stringify(existingpostImages));
            // audio
            formData.append('audio_exist', existingpostAudios.length > 0 ? true : false);
            formData.append('new_audio_exist', postaudiosData.length > 0 ? true : false);
            formData.append('old_audios', JSON.stringify(existingpostAudios));
            // pdfs
            formData.append('pdf_exist', existingpostPdfs.length > 0 ? true : false);
            formData.append('new_pdf_exist', postPdfsData.length > 0 ? true : false);
            formData.append('old_pdfs', JSON.stringify(existingpostPdfs));
            formData.append('post_pdf_names', JSON.stringify(postPdfNames));
            formData.append('external_video_link', externalLink);
            formData.append('from', 'mobile');

            postaudiosData.forEach((audio, index) => {
                formData.append(`audio-${index}`, audio);
            });
            postMediaFiles.forEach((media, index) => {
                formData.append(`media-${index}`, media);
            });
            postPdfsData.forEach((pdf, index) => {
                formData.append(`docs-${index}`, pdf);
            });

            const { data } = await axios.post('/social-posts/update', formData, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                },
                onUploadProgress: (progressEvent) => {
                    const progress = Math.round((progressEvent.loaded * 100) / progressEvent.total);
                    setUploadProgress(progress);
                }
            });

            if (data.success) {
                setOpenOption(false);
                // setPosts((posts) => [
                //     data.post,
                //     ...posts.filter((p) => {
                //         if (p.post_id !== data.post.post_id) {
                //             return p;
                //         }
                //     })
                // ]);
                setPosts((prev) => prev.map((p) => (p.post_id === data.post.post_id ? data.post : p)));
                setOpenEditor(false);
                toast.success(data.message);
            }
        } catch (err) {
            dispatch(activeLoader(false));
            console.log(err);
            toast.error('Failed to update post. Please try again.');
        } finally {
            seLoading(false);
            setUploadProgress(0);
        }
    };

    return (
        <Box
            sx={{
                position: 'fixed',
                top: 0,
                left: 0,
                width: '100vw',
                height: '100vh',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                backgroundColor: 'rgba(0, 0, 0, 0.5)',
                backdropFilter: 'blur(4px)',
                zIndex: 1000
            }}
        >
            <Card
                sx={{
                    width: { xs: '95%', md: '700px' },
                    maxHeight: '90vh',
                    position: 'relative',
                    borderRadius: '12px',
                    boxShadow: '0 8px 32px rgba(0, 0, 0, 0.1)',
                    backgroundColor: 'white'
                }}
            >
                <CardContent
                    sx={{
                        p: 3,
                        maxHeight: '85vh',
                        overflowY: 'auto',
                        '&::-webkit-scrollbar': {
                            display: 'none'
                        },
                        scrollbarWidth: 'none',
                        msOverflowStyle: 'none'
                    }}
                >
                    {/* Header */}
                    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 3 }}>
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                            <FiEdit3 size={20} color={theme.palette.primary.main} />
                            <Typography color="primary" sx={{ fontWeight: 600, fontSize: '1.1rem' }}>
                                Edit Your Post
                            </Typography>
                        </Box>
                        <IconButton
                            onClick={handleClose}
                            sx={{
                                color: 'text.secondary',
                                bgcolor: 'grey.100',
                                borderRadius: '50%',
                                '&:hover': { bgcolor: 'grey.300' }
                            }}
                        >
                            <FiX size={18} />
                        </IconButton>
                    </Box>

                    {/* Text Input */}
                    <Box sx={{ mb: 3 }}>
                        <textarea
                            ref={textInput}
                            placeholder="What's on your mind?"
                            value={text}
                            onChange={(e) => {
                                setText(e.target.value);
                                setValidatorMessage((prev) => prev.filter((item) => item.field !== 'post_details'));
                            }}
                            style={{
                                width: '100%',
                                minHeight: '120px',
                                padding: '16px',
                                border: '1px solid #E2E8F0',
                                borderRadius: '8px',
                                resize: 'vertical',
                                fontFamily: 'inherit',
                                fontSize: '1rem',
                                background: '#F8FAFC',
                                outline: 'none',
                                '&:focus': {
                                    borderColor: theme.palette.primary.main
                                }
                            }}
                        />

                        {validatorMessage.find((error) => error.field === 'post_details') && (
                            <Typography color="error" variant="caption" sx={{ mt: 1, display: 'block' }}>
                                {validatorMessage.find((error) => error.field === 'post_details').message}
                            </Typography>
                        )}
                    </Box>

                    {/* Media Options */}
                    <Box sx={{ mb: 3 }}>
                        <Typography variant="h6" sx={{ fontWeight: 600, mb: 2 }}>
                            Add to your post
                        </Typography>
                        <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap' }}>
                            <Button
                                variant={openImageUploader ? 'contained' : 'outlined'}
                                startIcon={<FiImage size={16} />}
                                onClick={() => {
                                    setOpenImageUploader(!openImageUploader);
                                    setOpenAudioUploader(false);
                                    setOpenPdfUploader(false);
                                    if (!openImageUploader) {
                                        setTimeout(() => imageInput.current.click(), 100);
                                    }
                                }}
                                sx={{
                                    textTransform: 'none',
                                    fontSize: '0.875rem',
                                    borderRadius: '8px'
                                }}
                            >
                                Photos/Videos
                            </Button>
                            <Button
                                variant={openAudioUploader ? 'contained' : 'outlined'}
                                startIcon={<FiMic size={16} />}
                                onClick={() => {
                                    setOpenAudioUploader(!openAudioUploader);
                                    setOpenPdfUploader(false);
                                    setOpenImageUploader(false);
                                    if (!openAudioUploader) {
                                        setTimeout(() => audioInput.current.click(), 100);
                                    }
                                }}
                                sx={{
                                    textTransform: 'none',
                                    fontSize: '0.875rem',
                                    borderRadius: '8px'
                                }}
                            >
                                Audio
                            </Button>
                            <Button
                                variant={openPdfUploader ? 'contained' : 'outlined'}
                                startIcon={<FiFile size={16} />}
                                onClick={() => {
                                    setOpenPdfUploader(!openPdfUploader);
                                    setOpenAudioUploader(false);
                                    setOpenImageUploader(false);
                                    if (!openPdfUploader) {
                                        setTimeout(() => pdfInput.current.click(), 100);
                                    }
                                }}
                                sx={{
                                    textTransform: 'none',
                                    fontSize: '0.875rem',
                                    borderRadius: '8px'
                                }}
                            >
                                Documents
                            </Button>
                        </Box>
                    </Box>

                    {/* Media Upload Sections */}
                    <Box sx={{ mb: 3 }}>
                        {/* Images/Videos */}
                        {(openImageUploader || postImages.length > 0 || existingpostImages.length > 0) && (
                            <Box sx={{ mb: 3 }}>
                                <Typography variant="subtitle1" sx={{ fontWeight: 600, mb: 2 }}>
                                    Photos & Videos
                                </Typography>

                                {/* Existing Images */}
                                {existingpostImages.length > 0 && (
                                    <>
                                        <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
                                            Existing Images
                                        </Typography>
                                        <Box
                                            sx={{
                                                display: 'grid',
                                                gridTemplateColumns: 'repeat(auto-fill, minmax(200px, 1fr))',
                                                gap: 2,
                                                mb: 2
                                            }}
                                        >
                                            {existingpostImages.map((image, index) => (
                                                <Box
                                                    key={`existing-img@${index}`}
                                                    sx={{
                                                        position: 'relative',
                                                        borderRadius: '8px',
                                                        overflow: 'hidden',
                                                        backgroundColor: '#F8FAFC',
                                                        border: '1px solid #E2E8F0',
                                                        '&:hover .delete-button': {
                                                            opacity: 1
                                                        }
                                                    }}
                                                >
                                                    <img
                                                        src={image}
                                                        alt="existing"
                                                        style={{
                                                            width: '100%',
                                                            height: '220px',
                                                            objectFit: 'contain',
                                                            display: 'block',
                                                            backgroundColor: '#F8FAFC'
                                                        }}
                                                    />
                                                    <IconButton
                                                        className="delete-button"
                                                        onClick={() => removeExistingImage(index)}
                                                        sx={{
                                                            position: 'absolute',
                                                            top: 4,
                                                            right: 4,
                                                            opacity: 0,
                                                            backgroundColor: 'rgba(255, 255, 255, 0.9)',
                                                            color: 'error.main',
                                                            '&:hover': { backgroundColor: 'error.lighter' },
                                                            transition: 'all 0.2s ease'
                                                        }}
                                                    >
                                                        <FiTrash2 size={16} />
                                                    </IconButton>
                                                </Box>
                                            ))}
                                        </Box>
                                    </>
                                )}

                                {/* New Images */}
                                {postImages.length > 0 ? (
                                    <>
                                        <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
                                            New Images
                                        </Typography>
                                        <Box
                                            sx={{
                                                display: 'grid',
                                                gridTemplateColumns: 'repeat(auto-fill, minmax(200px, 1fr))',
                                                gap: 2,
                                                mb: 2
                                            }}
                                        >
                                            {postImages.map((image, index) => (
                                                <Box
                                                    key={`img@${index}`}
                                                    sx={{
                                                        position: 'relative',
                                                        borderRadius: '8px',
                                                        overflow: 'hidden',
                                                        backgroundColor: '#F8FAFC',
                                                        border: '1px solid #E2E8F0',
                                                        '&:hover .delete-button': {
                                                            opacity: 1
                                                        }
                                                    }}
                                                >
                                                    {postMediaData[index]?.split(';base64')[0].split(':')[1].split('/')[0] === 'image' ? (
                                                        <img
                                                            src={image}
                                                            alt="uploaded"
                                                            style={{
                                                                width: '100%',
                                                                height: '220px',
                                                                objectFit: 'contain',
                                                                display: 'block',
                                                                backgroundColor: '#F8FAFC'
                                                            }}
                                                        />
                                                    ) : (
                                                        <Box sx={{ position: 'relative' }}>
                                                            <video
                                                                style={{
                                                                    width: '100%',
                                                                    height: '220px',
                                                                    objectFit: 'contain',
                                                                    display: 'block',
                                                                    backgroundColor: '#F8FAFC'
                                                                }}
                                                                src={image}
                                                                controls
                                                            />
                                                            <Box
                                                                sx={{
                                                                    position: 'absolute',
                                                                    top: '50%',
                                                                    left: '50%',
                                                                    transform: 'translate(-50%, -50%)',
                                                                    pointerEvents: 'none'
                                                                }}
                                                            >
                                                                <FiPlay size={24} color="white" />
                                                            </Box>
                                                        </Box>
                                                    )}
                                                    <IconButton
                                                        className="delete-button"
                                                        onClick={() => removeMediaFile(index)}
                                                        sx={{
                                                            position: 'absolute',
                                                            top: 4,
                                                            right: 4,
                                                            opacity: 0,
                                                            backgroundColor: 'rgba(255, 255, 255, 0.9)',
                                                            color: 'error.main',
                                                            '&:hover': { backgroundColor: 'error.lighter' },
                                                            transition: 'all 0.2s ease'
                                                        }}
                                                    >
                                                        <FiTrash2 size={16} />
                                                    </IconButton>
                                                </Box>
                                            ))}
                                        </Box>
                                        <Button
                                            variant="outlined"
                                            startIcon={<FiPlus size={16} />}
                                            onClick={() => imageInput.current.click()}
                                            sx={{ textTransform: 'none', borderRadius: '8px' }}
                                        >
                                            Add More Photos/Videos
                                        </Button>
                                    </>
                                ) : (
                                    <Box
                                        onClick={() => imageInput.current.click()}
                                        sx={{
                                            display: 'flex',
                                            flexDirection: 'column',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            p: 4,
                                            borderRadius: '8px',
                                            backgroundColor: '#F8FAFC',
                                            border: '1px dashed #CBD5E1',
                                            cursor: 'pointer',
                                            '&:hover': {
                                                backgroundColor: '#F1F5F9',
                                                borderColor: '#94A3B8'
                                            },
                                            transition: 'all 0.2s ease'
                                        }}
                                    >
                                        <RiUploadCloud2Line size={32} color={theme.palette.primary.main} />
                                        <Typography color="primary" sx={{ mt: 1, fontWeight: 500 }}>
                                            Click to upload photos or videos
                                        </Typography>
                                    </Box>
                                )}
                            </Box>
                        )}

                        {/* Audio Files */}
                        {(openAudioUploader || postAudios.length > 0 || existingpostAudios.length > 0) && (
                            <Box sx={{ mb: 3 }}>
                                <Typography variant="subtitle1" sx={{ fontWeight: 600, mb: 2 }}>
                                    Audio Files
                                </Typography>

                                {/* Existing Audio Files */}
                                {existingpostAudios.length > 0 && (
                                    <>
                                        <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
                                            Existing Audio Files
                                        </Typography>
                                        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1, mb: 2 }}>
                                            {existingpostAudios.map((audio, index) => (
                                                <Box
                                                    key={`existing-audio@${index}`}
                                                    sx={{
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                        p: 2,
                                                        borderRadius: '8px',
                                                        backgroundColor: '#F8FAFC',
                                                        border: '1px solid #E2E8F0',
                                                        '&:hover': {
                                                            backgroundColor: '#F1F5F9',
                                                            borderColor: '#CBD5E1'
                                                        },
                                                        transition: 'all 0.2s ease'
                                                    }}
                                                >
                                                    <FiMic size={20} color={theme.palette.primary.main} />
                                                    <Typography sx={{ ml: 2, flex: 1, fontSize: '0.875rem' }}>{audio}</Typography>
                                                    <IconButton
                                                        size="small"
                                                        onClick={() => removeExistingAudio(index)}
                                                        sx={{
                                                            color: 'text.secondary',
                                                            '&:hover': { color: 'error.main' }
                                                        }}
                                                    >
                                                        <FiTrash2 size={16} />
                                                    </IconButton>
                                                </Box>
                                            ))}
                                        </Box>
                                    </>
                                )}

                                {/* New Audio Files */}
                                {postAudios.length > 0 ? (
                                    <>
                                        <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
                                            New Audio Files
                                        </Typography>
                                        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1, mb: 2 }}>
                                            {postAudios.map((audio, index) => (
                                                <Box
                                                    key={`audio@${index}`}
                                                    sx={{
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                        p: 2,
                                                        borderRadius: '8px',
                                                        backgroundColor: '#F8FAFC',
                                                        border: '1px solid #E2E8F0',
                                                        '&:hover': {
                                                            backgroundColor: '#F1F5F9',
                                                            borderColor: '#CBD5E1'
                                                        },
                                                        transition: 'all 0.2s ease'
                                                    }}
                                                >
                                                    <FiMic size={20} color={theme.palette.primary.main} />
                                                    <Typography sx={{ ml: 2, flex: 1, fontSize: '0.875rem' }}>
                                                        Audio File {index + 1}
                                                    </Typography>
                                                    <IconButton
                                                        size="small"
                                                        onClick={() => removeAudioFile(index)}
                                                        sx={{
                                                            color: 'text.secondary',
                                                            '&:hover': { color: 'error.main' }
                                                        }}
                                                    >
                                                        <FiTrash2 size={16} />
                                                    </IconButton>
                                                </Box>
                                            ))}
                                        </Box>
                                        <Button
                                            variant="outlined"
                                            startIcon={<FiPlus size={16} />}
                                            onClick={() => audioInput.current.click()}
                                            sx={{ textTransform: 'none', borderRadius: '8px' }}
                                        >
                                            Add More Audio Files
                                        </Button>
                                    </>
                                ) : (
                                    <Box
                                        onClick={() => audioInput.current.click()}
                                        sx={{
                                            display: 'flex',
                                            flexDirection: 'column',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            p: 4,
                                            borderRadius: '8px',
                                            backgroundColor: '#F8FAFC',
                                            border: '1px dashed #CBD5E1',
                                            cursor: 'pointer',
                                            '&:hover': {
                                                backgroundColor: '#F1F5F9',
                                                borderColor: '#94A3B8'
                                            },
                                            transition: 'all 0.2s ease'
                                        }}
                                    >
                                        <FiMic size={32} color={theme.palette.primary.main} />
                                        <Typography color="primary" sx={{ mt: 1, fontWeight: 500 }}>
                                            Click to upload audio files
                                        </Typography>
                                    </Box>
                                )}
                            </Box>
                        )}

                        {/* Documents */}
                        {(openPdfUploader || postPdfs.length > 0 || existingpostPdfs.length > 0) && (
                            <Box sx={{ mb: 3 }}>
                                <Typography variant="subtitle1" sx={{ fontWeight: 600, mb: 2 }}>
                                    Documents
                                </Typography>

                                {/* Existing Documents */}
                                {existingpostPdfs.length > 0 && (
                                    <>
                                        <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
                                            Existing Documents
                                        </Typography>
                                        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1, mb: 2 }}>
                                            {existingpostPdfs.map((pdf, index) => (
                                                <Box
                                                    key={`existing-pdf@${index}`}
                                                    sx={{
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                        p: 2,
                                                        borderRadius: '8px',
                                                        backgroundColor: '#F8FAFC',
                                                        border: '1px solid #E2E8F0',
                                                        '&:hover': {
                                                            backgroundColor: '#F1F5F9',
                                                            borderColor: '#CBD5E1'
                                                        },
                                                        transition: 'all 0.2s ease'
                                                    }}
                                                >
                                                    <FiFile size={20} color={theme.palette.primary.main} />
                                                    <Typography
                                                        sx={{
                                                            ml: 2,
                                                            flex: 1,
                                                            fontSize: '0.875rem',
                                                            cursor: 'pointer',
                                                            '&:hover': { color: 'primary.main' }
                                                        }}
                                                        onClick={() => {
                                                            const href = typeof pdf === 'string' ? pdf : pdf?.url;
                                                            if (href) window.open(href, '_blank');
                                                        }}
                                                    >
                                                        {typeof pdf === 'string' ? pdf : pdf?.name || pdf?.url || 'Document'}
                                                    </Typography>
                                                    <IconButton
                                                        size="small"
                                                        onClick={() => removeExistingPdf(index)}
                                                        sx={{
                                                            color: 'text.secondary',
                                                            '&:hover': { color: 'error.main' }
                                                        }}
                                                    >
                                                        <FiTrash2 size={16} />
                                                    </IconButton>
                                                </Box>
                                            ))}
                                        </Box>
                                    </>
                                )}

                                {/* New Documents */}
                                {postPdfs.length > 0 ? (
                                    <>
                                        <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
                                            New Documents
                                        </Typography>
                                        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1, mb: 2 }}>
                                            {postPdfs.map((pdf, index) => (
                                                <Box
                                                    key={`pdf@${index}`}
                                                    sx={{
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                        p: 2,
                                                        borderRadius: '8px',
                                                        backgroundColor: '#F8FAFC',
                                                        border: '1px solid #E2E8F0',
                                                        '&:hover': {
                                                            backgroundColor: '#F1F5F9',
                                                            borderColor: '#CBD5E1'
                                                        },
                                                        transition: 'all 0.2s ease'
                                                    }}
                                                >
                                                    <FiFile size={20} color={theme.palette.primary.main} />
                                                    <Typography
                                                        sx={{
                                                            ml: 2,
                                                            flex: 1,
                                                            fontSize: '0.875rem',
                                                            cursor: 'pointer',
                                                            '&:hover': { color: 'primary.main' }
                                                        }}
                                                        onClick={() => {
                                                            const href = typeof pdf === 'string' ? pdf : pdf?.url;
                                                            if (href) window.open(href, '_blank');
                                                        }}
                                                    >
                                                        {(() => {
                                                            const name = postPdfNames[index];
                                                            if (typeof name === 'string') return name;
                                                            if (name && typeof name === 'object')
                                                                return name.name || name.url || 'Document';
                                                            return 'Document';
                                                        })()}
                                                    </Typography>
                                                    <IconButton
                                                        size="small"
                                                        onClick={() => removePdfFile(index)}
                                                        sx={{
                                                            color: 'text.secondary',
                                                            '&:hover': { color: 'error.main' }
                                                        }}
                                                    >
                                                        <FiTrash2 size={16} />
                                                    </IconButton>
                                                </Box>
                                            ))}
                                        </Box>
                                        <Button
                                            variant="outlined"
                                            startIcon={<FiPlus size={16} />}
                                            onClick={() => pdfInput.current.click()}
                                            sx={{ textTransform: 'none', borderRadius: '8px' }}
                                        >
                                            Add More Documents
                                        </Button>
                                    </>
                                ) : (
                                    <Box
                                        onClick={() => pdfInput.current.click()}
                                        sx={{
                                            display: 'flex',
                                            flexDirection: 'column',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            p: 4,
                                            borderRadius: '8px',
                                            backgroundColor: '#F8FAFC',
                                            border: '1px dashed #CBD5E1',
                                            cursor: 'pointer',
                                            '&:hover': {
                                                backgroundColor: '#F1F5F9',
                                                borderColor: '#94A3B8'
                                            },
                                            transition: 'all 0.2s ease'
                                        }}
                                    >
                                        <FiFile size={32} color={theme.palette.primary.main} />
                                        <Typography color="primary" sx={{ mt: 1, fontWeight: 500 }}>
                                            Click to upload documents
                                        </Typography>
                                    </Box>
                                )}
                            </Box>
                        )}
                    </Box>

                    {/* External Link */}
                    <Box sx={{ mb: 3 }}>
                        <InputLabel sx={{ color: 'text.primary', fontWeight: 500, mb: 1 }}>Add Youtube/URL/Link</InputLabel>
                        <OutlinedInput
                            type="text"
                            value={externalLink}
                            onChange={(e) => setExternalLink(e.target.value)}
                            placeholder="Paste URL here..."
                            fullWidth
                            sx={{
                                borderRadius: '8px',
                                backgroundColor: '#F8FAFC',
                                fontSize: '0.875rem'
                            }}
                        />
                    </Box>

                    {/* Progress Bar */}
                    {uploadProgress > 0 && (
                        <Box sx={{ mb: 3 }}>
                            <LinearProgress
                                variant="determinate"
                                value={uploadProgress}
                                sx={{
                                    borderRadius: '4px',
                                    height: '8px'
                                }}
                            />
                            <Typography variant="body2" color="text.secondary" align="center" sx={{ mt: 1 }}>
                                Uploading... {uploadProgress}%
                            </Typography>
                        </Box>
                    )}

                    {/* Submit Button */}
                    <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                        <Button
                            variant="contained"
                            onClick={updatePost}
                            disabled={loading || uploadProgress > 0}
                            sx={{
                                borderRadius: '8px',
                                textTransform: 'none',
                                fontSize: '1rem',
                                fontWeight: 600
                            }}
                        >
                            {loading || uploadProgress > 0 ? 'Updating...' : 'Update Post'}
                        </Button>
                    </Box>

                    {/* Hidden file inputs */}
                    <input
                        ref={imageInput}
                        type="file"
                        accept="image/*,video/*"
                        onChange={convertMedia}
                        style={{ display: 'none' }}
                        multiple
                    />
                    <input ref={audioInput} type="file" accept="audio/*" onChange={convertAudio} style={{ display: 'none' }} multiple />
                    <input
                        ref={pdfInput}
                        type="file"
                        accept=".pdf,.xlsx,.doc,.docx"
                        onChange={convertPdf}
                        style={{ display: 'none' }}
                        multiple
                    />
                </CardContent>
            </Card>
        </Box>
    );
};

export default EditPost;
